import { TicketStatus } from "@swivl-mono/types";
import { PopoverPosition, Select, SelectItem, SelectOutlet } from "@swivl-mono/ui";
import { IoIosArrowDown } from "react-icons/io";

type StatusBadgeProps = {
  status: TicketStatus;
  onChange: (status: TicketStatus) => void;
  disabled?: boolean;
};

export const statusConfig: Record<TicketStatus, { label: string; bg: string; text: string; caret: string }> = {
  [TicketStatus.ON_HOLD]: { label: "On Hold", bg: "bg-purple-50", text: "text-purple-500", caret: "caret-purple-500" },
  [TicketStatus.TODO]: { label: "To Do", bg: "bg-grey-200", text: "text-grey-900", caret: "caret-grey-900" },
  [TicketStatus.IN_PROGRESS]: { label: "In Progress", bg: "bg-yellow-50", text: "text-yellow-700", caret: "caret-yellow-700" },
  [TicketStatus.COMPLETED]: { label: "Completed", bg: "bg-teal-50", text: "text-teal-500", caret: "caret-teal-500" },
  [TicketStatus.CANCELLED]: { label: "Canceled", bg: "bg-grey-200", text: "text-grey-600", caret: "caret-grey-600" }
};

const statusOptions: SelectItem[] = [
  { label: statusConfig[TicketStatus.TODO].label, value: TicketStatus.TODO },
  { label: statusConfig[TicketStatus.IN_PROGRESS].label, value: TicketStatus.IN_PROGRESS },
  { label: statusConfig[TicketStatus.COMPLETED].label, value: TicketStatus.COMPLETED },
  { label: statusConfig[TicketStatus.ON_HOLD].label, value: TicketStatus.ON_HOLD },
  { type: "divider" as const },
  { label: statusConfig[TicketStatus.CANCELLED].label, value: TicketStatus.CANCELLED }
];

export function StatusBadge({ status, onChange, disabled }: StatusBadgeProps) {
  const config = statusConfig[status];

  return (
    <Select
      options={statusOptions}
      selectedValues={[status]}
      onChange={(selected) => onChange(selected[0] as TicketStatus)}
      disabled={disabled}
      position={PopoverPosition.RIGHT}
      styles={{ [SelectOutlet.POPOVER]: { minWidth: 200, width: "auto" } }}
      customTrigger={({ isOpen }) => (
        <button
          disabled={disabled}
          className={`inline-flex cursor-pointer items-center gap-1 rounded-2xl px-2 py-1 text-sm font-semibold ${config.bg} ${config.text} disabled:cursor-not-allowed disabled:opacity-50`}
        >
          {config.label}
          <IoIosArrowDown className={`h-3.5 w-3.5 transition-transform ${isOpen ? "rotate-180" : ""}`} />
        </button>
      )}
    />
  );
}
